<template>
  <div>
    <div class="modal fase" role="dialog" id="modal_add_sale_record_entry">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header" v-show="step < 3">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <h4>Despublicar vehículo por venta</h4>
          </div>

          <div class="modal-body">
            <div v-show="step === 1">
              <div class="center_query">
                <b>¿ Por que canal entró el cliente ?</b>
                <div>
                  <vue-multiselect
                      v-model="saleChannel"
                      label="name"
                      :options="saleChannels"
                      :searchable="true"
                      :close-on-select="true"
                      :show-labels="false"
                      class="multiselect_pse"
                      placeholder="Selecciona el canal"
                      @input="onSaleChannelChanged">
                    <span slot="noResult"></span>
                    <span slot="noOptions"></span>
                  </vue-multiselect>
                </div>
              </div>
            </div>

            <div v-show="step === 2">
              <div class="center_query" v-show="saleDate === null">
                <b>¿ Que día se vendió ?</b>
                <div>
                  <date-picker
                      v-model="saleDate"
                      :first-day-of-week="1"
                      lang="es"
                      class="date_picker"
                      :not-after="new Date()"></date-picker>
                </div>
              </div>
              <div class="center_query" v-show="saleDate !== null">
                <b>¿ Cual fué el importe real de la venta ?</b>
                <div>
                    <div class="input-group">
                      <span class="input-group-addon"><i class="fas fa-money-check-alt"></i></span>
                      <input type="number" step="1" class="form-control" min="1000" placeholder="Precio real de la venta" ref="price" v-on:keyup="checkPricePattern" v-model="price">
                    </div>
                </div>
              </div>
              <div class="center_query" v-show="price !== null && price >= 1000">
                <b>¿ Cuanta cantidad financió el cliente ?</b>
                <div>
                  <div class="input-group">
                    <span class="input-group-addon"><i class="fas fa-money-check-alt"></i></span>
                    <input type="number" step="1" class="form-control" min="1000" placeholder="Precio financiado por el cliente"  ref="financedPrice" v-on:keyup="checkFinancePricePattern" v-model="priceFinanced">
                  </div>
                </div>
              </div>
              <div class="center_query" v-show="priceFinanced >= 1000">
                <b>¿ En que entidad financió ?</b>
                 <div>
                   <vue-multiselect
                       v-model="bank"
                       label="name"
                       :options="banks"
                       :searchable="true"
                       :close-on-select="true"
                       :show-labels="false"
                       class="multiselect_pse"
                       placeholder="Selecciona la entidad">
                     <span slot="noResult"></span>
                     <span slot="noOptions"></span>
                   </vue-multiselect>
                 </div>
              </div>

              <div class="center_query" v-show="bank !== null || parseInt(priceFinanced) === 0">
                <b>Por último, ¿ De que provincia es el comprador ?</b>
                 <div>
                   <vue-multiselect
                       v-model="province"
                       label="name"
                       :options="provinces"
                       :searchable="true"
                       :close-on-select="true"
                       :show-labels="false"
                       class="multiselect_pse"
                       placeholder="Selecciona la provincia">
                     <span slot="noResult"></span>
                     <span slot="noOptions"></span>
                   </vue-multiselect>
                 </div>
              </div>

            </div>

            <div v-if="step === 3">
              <div class="center_query">
                <img src="../../assets/loading.gif" class="loading_img" /><br />
                <b>Enviando información…</b>
              </div>
            </div>

          </div>
          <div class="modal-footer" v-if="step < 3">
            <button type="button" class="btn btn-default" v-on:click="onClickBackBtn" v-if="(step > 1 && step < steps) && !loading">Atras</button>
            <button type="button" class="btn btn-info" v-bind:class="{disabled: loading}" v-on:click="onClickBtnContinue" v-if="step === 2 && province !== null || (saleChannel !== null && saleChannel.id === 10)">
              <span v-if="!loading">Continuar</span>
              <i class="fa fa-refresh fa-spin" v-if="loading"></i>
            </button>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal -->
    </div>
  </div>
</template>

<script>
import vueMultiselect from 'vue-multiselect'

import webservices from '@/utils/webservice'
import util from '@/utils/util'
import {logger} from '@/utils/Logger'
import DatePicker from 'vue2-datepicker'

export default {

  name: 'InsertSaleRecordEntryComponent',
  components: { vueMultiselect, DatePicker },

  data () {
    return {
      step: 1,
      steps: 3,
      substep: 0,
      carCode: null,
      saleChannel: null,
      saleChannels: [],
      price: null,
      priceFinanced: null,
      btnContinueActive: false,
      bank: null,
      banks: util.officialBanks(),
      province: null,
      provinces: util.provinces,
      saleDate: null,
      maxSaleDate: new Date(new Date().getTime() + 86400000).toString(),
      loading: false
    }
  },

  mounted () {
    webservices.sales.findActiveChannels().then(activeChannels => {
      this.saleChannels = activeChannels
    })
  },

  methods: {
    openForCar (carCode) {
      this.reset()
      this.carCode = carCode

      window.$('#modal_add_sale_record_entry').modal()
    },

    close () {
      window.$('#modal_add_sale_record_entry').modal('hide')
    },

    onSaleChannelChanged () {
      if (this.saleChannel !== null && this.saleChannel.id !== 10) {
        this.nextStep()
      }
    },
    nextStep () {
      this.btnContinueActive = false
      this.step++

      switch (this.step) {
        case 2:
          setTimeout(function (self) {
            self.$refs.price.focus()
          }, 0, this)
          // this.$refs.price.focus()
          break
      }
    },

    reset () {
      this.step = 1
      this.saleDate = null
      this.saleChannel = null
      this.price = null
      this.priceFinanced = null
      this.province = null
      this.bank = null
      this.loading = false
    },

    onClickBackBtn () {
      this.step--
      this.btnContinueActive = false
      if (this.step === 1) {
        this.reset()
      }
    },

    onClickBtnContinue () {
      // this.step = 3
      let saleChannel = this.saleChannel !== null ? this.saleChannel.id : null
      let price = this.price !== null ? parseInt(this.price) : null
      let priceFinanced = this.priceFinanced !== null ? parseInt(this.priceFinanced) : null
      let bank = this.bank !== null ? this.bank.id : null
      let province = this.province !== null ? this.province.id : null
      let saleDate = this.saleDate !== null ? this.saleDate.getTime() : null

      // console.log('onClickBtnContinue', { saleChannel, price, priceFinanced, bank, province, code: this.carCode })
      let requestLocalTime = new Date().getTime()
      this.loading = true
      webservices.sales.addSaleEntry(saleChannel, price, priceFinanced, bank, province, saleDate, this.carCode).then(response => {
        console.log(`response: ${JSON.stringify(response)}`)
        let responseLocalTime = new Date().getTime()
        let diffTime = responseLocalTime - requestLocalTime
        if (diffTime < 2000) {
          setTimeout((self) => {
            self.loading = false
            self.$emit('addedSaleEntry', response)
            self.close()
          }, 2000 - diffTime, this)
        } else {
          this.loading = false
          this.$emit('addedSaleEntry', response)
          this.close()
        }
      }).catch(error => {
        console.error(error)
        logger.error(error)
      })
    },

    checkPricePattern () {
      this.price = this.price.trim().replace(' ', '').replace('€', '').replace('.', '').replace(',', '')
      if (this.price < 0 || this.price === '') {
        this.price = null
      } else {
        if (this.price < 1000) {
          this.priceFinanced = null
        }
      }
    },

    checkFinancePricePattern () {
      if (this.priceFinanced !== null) {
        this.priceFinanced = this.priceFinanced.trim().replace(' ', '').replace('€', '').replace('.', '').replace(',', '')

        if (this.priceFinanced < 0 || this.priceFinanced === '') {
          this.priceFinanced = null
          this.btnContinueActive = false
        } else {
          if (this.priceFinanced === 0 || this.priceFinanced >= 1000) {
            this.btnContinueActive = true
          }
        }
      } else {
        this.btnContinueActive = false
      }
    }
  }
}
</script>

<style lang="scss">
  @import 'vue-multiselect/dist/vue-multiselect.min.css';

  div.center_query {
    text-align: center;

    .title {
      width: 100%;
      text-align: center;
    }

    .multiselect_pse {
      margin: 20px auto;
      max-width: 60%;
    }

    .date_picker {
      margin: 20px auto;
    }
    .input-group {
      max-width: 60%;
      margin: 20px auto;
    }
  }

  .multiselect--active {
    z-index: 9999;
  }

  .loading_img {
    text-align: center;
    margin: 0 auto;
  }

</style>



// WEBPACK FOOTER //
// src/components/custom/InsertSaleRecordEntryComponent.vue